import type { Address } from '@/model/address.model'
import type { Organization } from '@/types/organization'

export function getAddressFromOrganization(organization: Organization): Address {
  const parsedHouseNumber = Number.parseInt(organization.huisNummer ?? '')
  return {
    streetName: organization.straatnaam,
    houseNumber: parsedHouseNumber,
    houseNumberSuffix: organization.toevoeging ?? '',
    postalCode: organization.postcode,
    city: organization.stad,
    countryCode: organization.land,
  }
}

export function isPrivate(organization: Organization) {
  return !!organization.organisatieNummer?.match(/^PARTICULIER/)
}
